import { Box, FormHelperText, Stack, Typography } from '@mui/material';
import { useWatch } from 'react-hook-form';
import { CheckboxElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { tiktokDisclosureMessages as messages } from './tiktok-disclosure-messages';

/**
 * TikTok disclosure checkboxes: "Your brand" and "Branded content".
 * Shown when "Disclose video content" is on; at least one must be selected.
 * Branded content is disabled when visibility is "only me" (TikTok guideline).
 */
export function TiktokDisclosureCheckboxes() {
  const { formatMessage } = useIntl();
  const privacyLevel = useWatch({ name: 'privacyLevel' });
  const isPrivacyPrivate = privacyLevel === 'SELF_ONLY';

  return (
    <Stack spacing={1.5}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 2,
        }}
      >
        <CheckboxElement name="brandOrganic" />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography component="span" variant="subtitle2">
            {formatMessage(messages.yourBrandLabel)}
          </Typography>
          <Typography component="p" variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
            {formatMessage(messages.yourBrandDescription)}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 2,
        }}
      >
        <CheckboxElement name="brandContent" disabled={isPrivacyPrivate} />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            component="span"
            variant="subtitle2"
            color={isPrivacyPrivate ? 'text.disabled' : undefined}
          >
            {formatMessage(messages.brandedContentLabel)}
          </Typography>
          <Typography component="p" variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
            {formatMessage(messages.brandedContentDescription)}
          </Typography>
          {isPrivacyPrivate && (
            <FormHelperText sx={{ mt: 0.5, color: 'warning.main' }}>
              {formatMessage(messages.brandedContentVisibility)}
            </FormHelperText>
          )}
        </Box>
      </Box>
    </Stack>
  );
}
